function toDateOnly(value) {
  if (!value) return "";
  const stringValue = String(value).trim();
  if (!stringValue) return "";
  return stringValue.split(" ")[0].split("T")[0];
}

function toInteger(value) {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
}

function filterPeriod(period) {
  const hasRequired = period.day_id && period.start_id && period.end_id;
  if (!hasRequired) return null;
  return {
    day_id: toInteger(period.day_id),
    start_id: toInteger(period.start_id),
    end_id: toInteger(period.end_id),
  };
}

function filterBreakPeriod(period) {
  const p = period || {};
  const hasCompleteTimes = p.start_id && p.end_id;
  if (!hasCompleteTimes) return null;
  return {
    start_id: toInteger(p.start_id),
    end_id: toInteger(p.end_id),
    starts_at: toDateOnly(p.starts_at),
    ends_at: toDateOnly(p.ends_at),
  };
}

export const formatWeekPeriodsForApi = (periods = []) =>
  periods.map(filterPeriod).filter(Boolean);

export const formatBreakPeriodsForApi = (periods = []) => {
  const firstBreakPeriod = periods[0] || {};
  const formattedBreakPeriod = filterBreakPeriod(firstBreakPeriod);
  return formattedBreakPeriod ? [formattedBreakPeriod] : [];
};

export const FormatterUnits = (
  objData,
  parkingsData,
  transports,
  isActiveParking,
  isCreate,
  objectDataImg
) => {
  const { insurances, channels, category_ids: categories } = objData;
  const covenant_ids = insurances.value?.map((item) => item.id) || [];
  const channels_id = channels.value?.map((item) => item.id) || [];
  const category_ids = categories?.value?.map((item) => item.id) || [];

  let obj = {};

  let parkingsArray = [];

  if (!isActiveParking) parkingsData = [];
  if (transports[0].transport === "") transports = [];

  function filteredDeleted(array) {
    const filterCreateUpdateMethod = array.filter(
      (item) => item.isCreatedInMethodUpdate
    );
    const filteredDeleted = filterCreateUpdateMethod.filter(
      (item) => !item.deleted
    );

    const filteredNotCreatedUpdateMethod = array.filter(
      (item) => !item.isCreatedInMethodUpdate
    );
    const newArray = [...filteredDeleted, ...filteredNotCreatedUpdateMethod];

    return newArray;
  }

  parkingsData.forEach((obj) => {
    let parkings = {};

    Object.keys(obj).forEach((parking) => {
      if (_verifyIsParking(parking)) {
        parkings = {
          ...parkings,
          addresses: {
            ...parkings.addresses,
            [parking]: obj[parking].value,
            city_id: objData.city_id.value,
          },
        };
        return;
      }

      if (parking === "deleted") {
        parkings = {
          ...parkings,
          deleted: obj[parking],
        };
        return;
      }

      parkings = {
        ...parkings,
        [parking]: obj[parking].value,
        isCreatedInMethodUpdate: obj.isCreatedInMethodUpdate,
      };
    });

    parkingsArray = [...parkingsArray, parkings];
  });

  parkingsArray = filteredDeleted(parkingsArray);
  const transportsArray = filteredDeleted(transports);

  Object.keys(objData).forEach((name) => {
    if (_verifyIsAddress(name)) {
      const _obj = objData.address_id ? { address_id: objData.address_id } : {};
      if (name === "cep") {
        obj = {
          ...obj,
          addresses: {
            cep: objData.cep.value,
            ...obj.addresses,
          },
        };
        return;
      }

      if (transports) {
        obj = {
          ...obj,
          transports: JSON.stringify(transportsArray),
        };
      }

      if (parkingsArray) {
        obj = {
          ...obj,
          parkings: JSON.stringify(parkingsArray),
        };
      }

      obj = {
        ...obj,
        addresses: {
          ...obj.addresses,
          [name]: objData[name].value,
          city_id: objData.city_id.value,
          ..._obj,
        },
      };
      return;
    }
    if (name === "insurances") {
      obj = {
        ...obj,
        covenant_ids,
      };
      return;
    }

    if (name === "region_id") {
      const value = objData[name].value.id;
      obj = {
        ...obj,
        region_id: value,
      };
      return;
    }

    if (name === "slug") {
      const { value } = objData[name];
      obj = {
        ...obj,
        slug: value.toLowerCase(),
      };
      return;
    }

    if (name === "division_id") {
      const value = objData[name].value.id;
      obj = {
        ...obj,
        division_id: value,
      };
      return;
    }

    if (name === "type") {
      const { value } = objData[name];
      obj = {
        ...obj,
        type: value,
      };
      return;
    }

    if (name === "channels") {
      obj = {
        ...obj,
        channels_ids: channels_id,
      };
      return;
    }

    if (name === "category_ids") {
      obj = {
        ...obj,
        category_ids,
      };
      return;
    }

    if (name === "reference") {
      if (objData[name].value) {
        const { value } = objData[name];
        obj = {
          ...obj,
          reference: value.replace(/"/g, "'"),
        };
      }
      return;
    }

    if (name === "unit_periods") {
      obj = {
        ...obj,
        unit_periods: formatWeekPeriodsForApi(objData[name].value),
      };
      return;
    }

    if (name === "report_periods") {
      obj = {
        ...obj,
        report_periods: formatWeekPeriodsForApi(objData[name].value),
      };
      return;
    }

    if (name === "collect_periods") {
      obj = {
        ...obj,
        collect_periods: formatWeekPeriodsForApi(objData[name].value),
      };
      return;
    }

    if (name === "break_periods") {
      obj = {
        ...obj,
        break_periods: formatBreakPeriodsForApi(objData[name].value),
      };
      return;
    }

    if (name === "unmet_products") {
      if (objData[name].value) {
        const { value } = objData[name];
        obj = {
          ...obj,
          unmet_products: value.replace(/"/g, "'"),
        };
      }
      return;
    }

    if (name === "covenant") return;
    if (name === "region") return;
    if (name === "city_id") return;
    if (name === "rapid_tests") return;

    obj = {
      ...obj,
      [name]: objData[name].value,
    };
  });

  return obj;
};

function createDefaultBreak() {
  return {
    start_id: "",
    end_id: "",
    starts_at: "",
    ends_at: "",
  };
}

function createDefaultWeekPeriods() {
  return [1, 2, 3, 4, 5, 6].map((day_id) => ({
    day_id,
    start_id: "",
    end_id: "",
  }));
}

function mapWeekPeriodsFromApi(periods) {
  const defaultPeriods = createDefaultWeekPeriods();
  if (!Array.isArray(periods) || periods.length === 0) {
    return defaultPeriods;
  }

  const periodByDay = new Map(
    periods
      .filter((item) => item?.day_id)
      .map((item) => [
        Number(item.day_id),
        {
          day_id: Number(item.day_id),
          start_id: item.start_id ?? "",
          end_id: item.end_id ?? "",
        },
      ])
  );

  return defaultPeriods.map((defaultPeriod) => {
    return periodByDay.get(defaultPeriod.day_id) ?? defaultPeriod;
  });
}

export const FormatterImgUnitMap = (proFilesImageMap) => {
  const formData = new FormData();

  proFilesImageMap.forEach((file) => {
    formData.append("image_map[]", file);
  });

  return formData;
};

export const FormatterImgUnit = (profiles, proFilesImageMap) => {
  const formData = new FormData();

  profiles.forEach((file) => {
    formData.append("images[]", file);
  });

  proFilesImageMap.forEach((file) => {
    formData.append("image_map[]", file);
  });

  return formData;
};

export const UnFormattedUnits = (
  bodyData,
  parkingsInital,
  transportInitial,
  setParkingsActive,
  setTransportActive
) => {
  let obj = {};
  let parkingsData = {};
  let transportsData = {};
  let parkingsArray = [];
  Object.keys(bodyData).forEach((name) => {
    if (
      name === "unit_periods" ||
      name === "report_periods" ||
      name === "collect_periods"
    ) {
      obj = {
        ...obj,
        [name]: {
          value: mapWeekPeriodsFromApi(bodyData[name]),
          error: "",
        },
      };
      return;
    }

    if (name === "rapid_tests") {
      const list = Array.isArray(bodyData[name]) ? bodyData[name] : [];
      obj = {
        ...obj,
        rapid_tests: {
          value: list.map((item) => ({
            id: item.id,
            product: item.product ?? "",
            sub_category: item.sub_category ?? "",
          })),
          error: "",
        },
      };
      return;
    }

    if (name === "break_periods") {
      const raw = bodyData.break_periods;
      const breakPeriods = Array.isArray(raw)
        ? raw.map((item) => ({
            start_id: item?.start_id ?? "",
            end_id: item?.end_id ?? "",
            starts_at: toDateOnly(item?.starts_at),
            ends_at: toDateOnly(item?.ends_at),
          }))
        : raw && typeof raw === "object"
        ? [
            {
              start_id: raw.start_id ?? "",
              end_id: raw.end_id ?? "",
              starts_at: toDateOnly(raw.starts_at),
              ends_at: toDateOnly(raw.ends_at),
            },
          ]
        : [createDefaultBreak()];
      obj = {
        ...obj,
        break_periods: {
          value: breakPeriods.length ? breakPeriods : [createDefaultBreak()],
          error: "",
        },
      };
      return;
    }

    if (name === "registered_by" || name === "warnings" || name === "holidays")
      return;
    if (name === "images" || name === "image_map") {
      obj = {
        ...obj,
      };
      return;
    }

    if (name === "addresses") {
      Object.keys(bodyData[name]).forEach((_name) => {
        if (_name === "default") return;

        if (_name === "cities") {
          obj = {
            ...obj,
            city_id: {
              value: bodyData.addresses[_name].id,
              error: "",
              cities: [bodyData.addresses[_name]],
            },
          };
          return;
        }

        if (_name === "id") {
          obj = {
            ...obj,
            address_id: bodyData.addresses[_name],
          };
          return;
        }
        obj = {
          ...obj,
          [_name]: {
            value: bodyData.addresses[_name],
            error: "",
          },
        };
      });

      return;
    }

    if (name === "parkings") {
      if (bodyData[name].length === 0) {
        parkingsArray = [parkingsInital];
        return;
      }
      setParkingsActive(true);
      bodyData[name].forEach((obj) => {
        Object.keys(obj).forEach((item) => {
          if (item === "opening_time") return;
          if (item === "addresses") {
            Object.keys(obj[item]).forEach((obj_address) => {
              if (
                obj_address === "cities" ||
                obj_address === "default" ||
                obj_address === "id"
              )
                return;
              if (_verifyIsParking(obj_address)) {
                parkingsData = {
                  ...parkingsData,
                  [obj_address]: {
                    value: obj[item][obj_address],
                    error: "",
                  },
                };
                return;
              }
              parkingsData = {
                ...parkingsData,
                [item]: { value: obj[item], error: "" },
              };
            });
            return;
          }
          parkingsData = {
            ...parkingsData,
            [item]: { value: obj[item], error: "" },
            isCreatedInMethodUpdate: false,
          };
        });
        parkingsArray = [...parkingsArray, parkingsData];
      });
      return;
    }

    if (name === "transports") {
      if (bodyData[name].length === 0) {
        transportsData = [transportInitial];
        return;
      }
      setTransportActive(true);
      transportsData = bodyData[name];
      return;
    }

    if (name === "covenants") {
      const newArray = bodyData[name].map((item) => ({
        id: item.id,
        covenant: item.covenant,
      }));
      obj = {
        ...obj,
        insurances: {
          value: newArray,
          error: "",
        },
      };
      return;
    }

    if (name === "region") {
      obj = {
        ...obj,
        region_id: {
          value: {
            id: bodyData[name]?.id,
            region: bodyData[name]?.region,
          },
          error: "",
        },
      };
      return;
    }

    if (name === "divisions") {
      obj = {
        ...obj,
        division_id: {
          value: bodyData[name],
          error: "",
        },
      };
    }

    if (name === "categories") {
      obj = {
        ...obj,
        category_ids: {
          value: bodyData[name],
          error: "",
        },
      };
    }

    obj = {
      ...obj,
      [name]: {
        value: bodyData[name] ?? "",
        error: "",
      },
    };

    return;
  });

  if (!obj.collect_periods) {
    obj = {
      ...obj,
      collect_periods: {
        value: mapWeekPeriodsFromApi(undefined),
        error: "",
      },
    };
  }

  return { obj, parkingsData: parkingsArray, transportsData };
};

function _verifyIsAddress(name) {
  const addressField = [
    "neighborhood",
    "street",
    "number",
    "complement",
    "cep",
    "latitude",
    "longitude",
  ];
  return addressField.some((field) => field === name);
}

function _verifyIsParking(name) {
  const addressField = [
    "neighborhood",
    "street",
    "number",
    "complement",
    "cep",
    "latitude",
    "longitude",
  ];
  return addressField.some((field) => field === name);
}
